import { render } from "./CloseXButton.vue?vue&type=template&id=f528bf70"
import script from "./CloseXButton.vue?vue&type=script&lang=js"
export * from "./CloseXButton.vue?vue&type=script&lang=js"
script.render = render

export default script